import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Car } from "lucide-react";
import { Button } from "../ui/button";

const MobileBookingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  // Don't show on booking or thank-you pages
  const hideOnPages = ["/booking", "/thank-you"];
  const shouldHide = hideOnPages.includes(location.pathname) || location.pathname.startsWith("/admin");

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (shouldHide) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-40 lg:hidden"
          data-testid="mobile-booking-cta"
        >
          <div className="bg-white border-t border-slate-200 shadow-strong px-4 py-3">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-midnight-navy rounded-full">
                  <Car className="w-5 h-5 text-champagne-gold" />
                </div>
                <div>
                  <p className="text-sm font-medium text-midnight-navy">
                    Book Your Transfer
                  </p>
                  <p className="text-xs text-slate-500">
                    From €70 · Pay driver on arrival
                  </p>
                </div>
              </div>
              <Button
                asChild
                className="bg-champagne-gold hover:bg-champagne-gold/90 text-midnight-navy font-bold px-6 py-2.5 rounded-full shadow-md"
                data-testid="mobile-cta-book-btn"
              >
                <Link to="/booking">Book Now</Link>
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileBookingCTA;
